import moment from "moment";

export const controls = `<div class="plyr__controls">
      <div class="plyr__dim"></div>
      <div class="plyr__controls__left">
        <button class="plyr__controls__item plyr__control" type="button" data-plyr="play" aria-label="Play">
          <svg class="icon--pressed" aria-hidden="true" focusable="false">
            <use xlink:href="#plyr-pause"></use>
          </svg>
          <svg class="icon--not-pressed" aria-hidden="true" focusable="false">
            <use xlink:href="#plyr-play"></use>
          </svg>
          <span class="label--pressed plyr__sr-only">Pause</span><span
            class="label--not-pressed plyr__sr-only">Play</span></button>
        <div class="plyr__controls__item plyr__volume">
          <button type="button" class="plyr__control" data-plyr="mute">
            <svg class="icon--pressed" aria-hidden="true" focusable="false">
              <use xlink:href="#plyr-muted"></use>
            </svg>
            <svg class="icon--not-pressed" aria-hidden="true" focusable="false">
              <use xlink:href="#plyr-volume"></use>
            </svg>
            <span class="label--pressed plyr__sr-only">Unmute</span><span
              class="label--not-pressed plyr__sr-only">Mute</span></button>
          <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" role="slider"
                 aria-label="Volume" aria-valuemin="0" aria-valuemax="100" aria-valuenow="30" id="plyr-volume-3653"
                 aria-valuetext="" style=""></div>
        <div class="chapters-button" id="chapter">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bars" role="img"
               xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-bars fa-w-14 fa-2x">
            <path fill="currentColor"
                  d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                  class=""></path>
          </svg>
        </div>
        <div class="plyr__controls__item plyr__progress__container">
          <div class="plyr__progress">
            <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" autocomplete="off"
                   role="slider" aria-label="Seek" aria-valuemin="0" aria-valuemax="" aria-valuenow=""
                   id="plyr-seek-3653" aria-valuetext="20:02 of 1:24:32" style="" seek-value="">
            <progress class="plyr__progress__buffer" min="0" max="100" value="" role="progressbar" aria-hidden="true">%
              buffered
            </progress>
            <span class="plyr__tooltip" style=""></span>
          </div>
        </div>
        <div class="plyr__time plyr__time--current plyr__time-none" aria-label="Current time">00:00</div>
        <div class="plyr__time plyr__time--duration plyr__time-none" aria-label="Duration duration">00:00</div>
        <div class="plur-cuurent__chapter" id="chapterTitle"></div>
      </div>
      <div class="plyr__controls__right">
        <button class="plyr__controls__item plyr__control" type="button" data-plyr="captions">
          <svg class="icon--pressed" aria-hidden="true" focusable="false">
            <use xlink:href="#plyr-captions-on"></use>
          </svg>
          <svg class="icon--not-pressed" aria-hidden="true" focusable="false">
            <use xlink:href="#plyr-captions-off"></use>
          </svg>
          <span class="label--pressed plyr__sr-only">Disable captions</span><span
            class="label--not-pressed plyr__sr-only">Enable captions</span></button>
        <div class="plyr__controls__item plyr__menu">
          <button aria-haspopup="true" data-iddd="id" id="settings" aria-expanded="false" type="button" class="plyr__control" data-plyr="settings">
            <svg aria-hidden="true" focusable="false"><use xlink:href="#plyr-settings"></use></svg><span class="plyr__tooltip">Settings</span>
          </button>
          <div class="plyr__menu__container" data-idd="id" >
            <div>
              <div id="" data-id="id">
                <div role="menu">
                  <button data-plyr="settings" type="button" class="plyr__control plyr__control--forward"
                          role="menuitem" aria-haspopup="true"><span>Speed<span class="plyr__menu__value">Normal</span></span>
                  </button>
                </div>
              </div>
              <div id="" data-ig="id">
                <button type="button" class="plyr__control plyr__control--back"><span aria-hidden="true">Captions</span><span
                    class="plyr__sr-only">Go back to previous menu</span></button>
                <div role="menu"></div>
              </div>
              <div id="" data-iw="id" >
                <button type="button" class="plyr__control plyr__control--back"><span
                    aria-hidden="true">Quality</span><span class="plyr__sr-only">Go back to previous menu</span>
                </button>
                <div role="menu"></div>
              </div>
              <div data-iq="id" id="" >
                <button type="button" class="plyr__control plyr__control--back"><span
                    aria-hidden="true">Speed</span><span class="plyr__sr-only">Go back to previous menu</span></button>
                <div role="menu">
                  <button data-plyr="speed" type="button" role="menuitemradio" class="plyr__control"
                          aria-checked="false" value="0.5"><span>0.5×</span></button>
                  <button data-plyr="speed" type="button" role="menuitemradio" class="plyr__control"
                          aria-checked="false" value="0.75"><span>0.75×</span></button>
                  <button data-plyr="speed" type="button" role="menuitemradio" class="plyr__control" aria-checked="true"
                          value="1"><span>Normal</span></button>
                  <button data-plyr="speed" type="button" role="menuitemradio" class="plyr__control"
                          aria-checked="false" value="1.25"><span>1.25×</span></button>
                  <button data-plyr="speed" type="button" role="menuitemradio" class="plyr__control"
                          aria-checked="false" value="1.5"><span>1.5×</span></button>
                  <button data-plyr="speed" type="button" role="menuitemradio" class="plyr__control"
                          aria-checked="false" value="1.75"><span>1.75×</span></button>
                  <button data-plyr="speed" type="button" role="menuitemradio" class="plyr__control"
                          aria-checked="false" value="2"><span>2×</span></button>
                </div>
              </div>
            </div>
          </div>
          <button class="plyr__controls__item plyr__control" type="button" data-plyr="fullscreen">
            <svg class="icon--pressed" aria-hidden="true" focusable="false">
              <use xlink:href="#plyr-exit-fullscreen"></use>
            </svg>
            <svg class="icon--not-pressed" aria-hidden="true" focusable="false">
              <use xlink:href="#plyr-enter-fullscreen"></use>
            </svg>
            <span class="label--pressed plyr__sr-only">Exit fullscreen</span><span
              class="label--not-pressed plyr__sr-only">Enter fullscreen</span></button>
        </div>
      </div>
    </div>`;

export const chapters = {
    methods: {
        seekToTime(seconds) {
            if (this.$refs.plyr) {
                const iframe = this.$refs.plyr.embed;
                if (iframe && iframe.contentWindow && iframe.contentWindow.postMessage) {
                    iframe.contentWindow.postMessage(
                        JSON.stringify({
                            event: "command",
                            func: "seekTo",
                            args: [seconds, true],
                        }),
                        "*"
                    );
                }
            }
        },
        toggleBtnChapter() {
            document.getElementById("chapters").addEventListener("click", () => {
                document.getElementById("chapters").classList.toggle("show-list");
            });
        },
        changeChapter(item) {
            this.$refs.plyr.player.currentTime = moment
                .duration(item.timeFrom)
                .asSeconds();
            this.currentItem = item;
            this.closeList();

            this.$bus.$emit("video-start");
        },

        changeSpeed(item) {
            this.$refs.plyr.player.speed = item;
            this.selectedSpeed = item;
            this.isShowSettings = false;
        },

        closeList() {
            this.$refs.plyr.$el.classList.toggle("plyr__chapters-show");
            this.isShowChapters = false;
        },
    },
    created() {
        // @TODO reset plyr cnf
        localStorage.setItem("plyr", "");
    },

    mounted() {
        // if(!this.$refs.plyr ||!this.data.hasOwnProperty('chapters')) return;

        const player = this.$refs.plyr.player;
        const chapterList = this.data.chapters ? this.data.chapters.data : [];

        var chapterTitleElement;
        var elVideo;

        this.$refs.plyr.player.on("ready", (event) => {
            elVideo = document.getElementById("video");

            chapterTitleElement = document.getElementById("chapterTitle");
            this.$refs.plyr.player.speed = 1;

            //chapters
            const elem = document.getElementById("chapter");

            if (elem) {
                elem.addEventListener("click", () => {
                    this.$refs.plyr.$el.classList.toggle("plyr__chapters-show");
                    this.isShowChapters = !this.isShowChapters;
                });
            }

            // if (this.data.chapters && !this.data.chapters.data.length) {
            //   elem.hidden = true;
            //   chapterTitleElement.hidden = true;
            // };

            //settings
            const settingElem = document.getElementById("settings");

            if (settingElem) {
                settingElem.addEventListener("click", () => {
                    this.$refs.plyr.$el.classList.toggle("plyr__settings-show");
                    this.isShowSettings = !this.isShowSettings;
                });
            }
        });

        // function to INTERVAL
        function cb() {
            if (chapterTitleElement) {
                chapterTitleElement.innerText = "";
            }

            if (chapterList) {
                chapterList.forEach((elem) => {
                    if (player.currentTime > moment.duration(elem.timeFrom).asSeconds()) {
                        if (chapterTitleElement) {
                            chapterTitleElement.innerText = elem.description;
                        }
                    }
                });
            }
        }

        this.$refs.plyr.player.on("play", () => {
            setTimeout(() => {
                elVideo.classList.remove("has-pause");
                elVideo.classList.add("has-play");
            }, 200);

            this.time = setInterval(cb, 1000);

            const plyrTime = document.querySelectorAll(".plyr__time");

            for (let time of plyrTime) {
                time.classList.remove("plyr__time-none");
            }
        });

        this.$refs.plyr.player.on("pause", () => {
            elVideo.classList.remove("has-play");
            elVideo.classList.add("has-pause");

            clearInterval(this.time);
        });

        this.$bus.$on("event-video-start", (time) => {
            if (time) player.forward(+time);

            setTimeout(() => {
                player.play();
            }, 1500);
        });
    },
    beforeDestroy() {
        if (document.getElementById("chapter")) {
            document.getElementById("chapter").removeEventListener("click", () => {});
        }
    },
};
